import { memo, useState, useCallback } from 'react';
import type { NodeProps, Node } from '@xyflow/react';
import { withDefaults } from '../with-defaults';
import { makeDefault } from './defaults';
import type { GifData } from './types';
import { SelectionTransformer } from '@/features/canvas/engine/selection/selection-transformer';
import styles from './component.module.css';

type GifNodeShape = Node<GifData, 'gif'>;

export default memo(function GifNode({ id, data, selected, dragging }: NodeProps<GifNodeShape>) {
  const d = withDefaults(data, makeDefault);
  const [pinned, setPinned] = useState(false);
  const [hovered, setHovered] = useState(false);
  const onToggle = useCallback(() => setPinned((p) => !p), []);

  const animated = pinned || hovered;

  const ghost = (
    <div className={styles.root}>
      <img
        src={d.stillUrl}
        alt=""
        className={styles.img}
      />
    </div>
  );

  return (
    <SelectionTransformer
      nodeId={id}
      nodeType="gif"
      selected={!!selected}
      dragging={!!dragging}
      ghostContent={ghost}
      gifState={{ playing: pinned, onToggle }}
    >
      <div className={styles.root}>
        <img
          src={animated ? d.url : d.stillUrl}
          alt="GIF"
          className={styles.img}
          onMouseEnter={() => !pinned && setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        />
      </div>
    </SelectionTransformer>
  );
});
